import React from 'react';
import { motion } from 'framer-motion';
import { FlaskConical } from 'lucide-react';
export function Revelation() {
  return <section className="py-20 md:py-28 px-4 bg-brand-darker border-y border-brand-gray relative overflow-hidden" data-id="element-113">
      <div className="absolute inset-0 bg-radial-glow opacity-30 pointer-events-none" data-id="element-114" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-10" data-id="element-116">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-orange/10 border border-brand-orange/40 mb-6" data-id="element-117">
            <FlaskConical className="w-8 h-8 text-brand-orange" data-id="element-118" />
          </div>
          <span className="block text-brand-orange font-bold tracking-widest text-xs md:text-sm uppercase mb-4" data-id="element-119">
            — La Revelación —
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-white uppercase" data-id="element-120">
            Ciencia, <span className="text-brand-orange" data-id="element-121">no ficción</span>.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-6 text-lg md:text-xl text-brand-text leading-relaxed max-w-3xl mx-auto" data-id="element-122">
          <p data-id="element-123">
            La mayoría de los programas te piden que te conviertas en un{' '}
            <em className="text-brand-muted" data-id="element-124">"atleta de tiempo completo"</em>.
            Pero tú eres un hombre ocupado.{' '}
            <strong className="text-white" data-id="element-125">No tienes tiempo para eso.</strong>
          </p>
          <p data-id="element-126">
            El Protocolo Alpha no es un programa de fitness genérico.{' '}
            <strong className="text-brand-orange" data-id="element-127">
              Es una auditoría química.
            </strong>
          </p>
          <p data-id="element-128">
            Hemos destilado la ciencia de los ritmos circadianos y la nutrición
            de microrreset en un protocolo ejecutable de 3 semanas. Te enseñamos
            a señalizar a tu cuerpo que{' '}
            <strong className="text-white" data-id="element-129">
              todavía eres el líder de la manada
            </strong>{' '}
            mediante cambios estratégicos en cuándo ves la luz, qué bebes al
            despertar y cómo entrenas durante solo 15 minutos.
          </p>
        </motion.div>
      </div>
    </section>;
}